import React, { useState } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';
import './ForgotUsername.css';

const ForgotUsername = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleForgotUsername = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post('https://lionfish-app-w73zu.ondigitalocean.app/api/forgot_username/', { email });
      setMessage(response.data.message || "If the email exists, you will receive an email with your username.");
    } catch (error) {
      console.error("Username recovery request failed:", error);
      setMessage("An error occurred while requesting username recovery.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-username-container">
      <form onSubmit={handleForgotUsername} className="forgot-username-form">
        <h2>Forgot Username?</h2>
        <p className="forgot-username-description">
          Enter the email address associated with your account and we'll send you your username.
        </p>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? "Sending..." : "Send Username"}
        </button>
        {message && <p className="forgot-username-message">{message}</p>}
      </form>
      <p>
        Remembered your username? <Link to="/login">Login</Link>
      </p>
      <p>
        Forgot your password? <Link to="/forgot-password">Reset Password</Link>
      </p>
    </div>
  );
};

export default ForgotUsername;